var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMoreHelpMail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 64,
    height: 64,
    rx: 32,
    fill: "#84BDF3"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M48 16H16C13.8 16 12.02 17.8 12.02 20L12 44C12 46.2 13.8 48 16 48H48C50.2 48 52 46.2 52 44V20C52 17.8 50.2 16 48 16ZM48 24L32 34L16 24V20L32 30L48 20V24Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMoreHelpMail);
export default __webpack_public_path__ + "static/media/MoreHelpMail.ab15ae540e15907ad716eb86267b07f0.svg";
export { ForwardRef as ReactComponent };